module.exports = __webpack_public_path__ + "img/adulthood-rites.2b87f7f8.png";